
<template>
    <svg version="1.1" id="_x31_0" x="0px" y="0px" viewBox="0 0 512 512" style="width: 1em; height: 1em; opacity: 1;" xml:space="preserve">
        <polygon class="st0" points="45.852,0.002 0,0.002 0,511.998 511.996,511.998 511.996,466.146 45.852,466.146 	" style="fill: rgb(75, 75, 75);"></polygon>
        <path class="st0" d="M138.09,0.002h-35.978v409.889H512v-35.982C338.152,311.712,200.286,173.842,138.09,0.002z M134.259,74.125 c37.823,78.706,90.715,148.088,155.074,204.952v98.666H134.259V74.125z" style="fill: rgb(75, 75, 75);"></path>
        <polygon class="st0" points="304.587,83.41 433.019,83.41 433.019,112.932 511.996,67.336 433.019,21.739 433.019,51.262 304.587,51.262 304.587,21.739 225.61,67.336 304.587,112.932 	" style="fill: rgb(75, 75, 75);"></polygon>
    </svg>
</template>
<script>
export default {
  name: 'longtailicon',
  components: {
  },
  created() {
  }
}
</script>
